import script from "./BottomNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./BottomNavigation.vue?vue&type=script&setup=true&lang=js"

import "./BottomNavigation.vue?vue&type=style&index=0&id=32d26319&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\cgproject\\canggu-official-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32d26319"]])

export default __exports__